import React from "react";
import { Flex } from "theme-ui";
import { buttons } from "../../gatsby-plugin-theme-ui/variants";
import { colors } from "../../gatsby-plugin-theme-ui/colors";
import { ButtonProps, ButtonVariantProps } from "../../../custom";
import { Link } from "gatsby-link";

export interface Props {
  className?: string;
  ref?: string;
  large?: boolean;
  id?: string;
  ariaLabel?: string;
  onClick?: () => void;
  removeAnimation?: boolean;
}

const Button = ({
  href,
  to,
  ref,
  id,
  ariaLabel,
  text,
  variant,
  type,
  disabled,
  large,
  onClick,
  className,
  removeAnimation,
}: Props & ButtonProps) => {
  const isOutline = variant === "outline-green";
  return (
    <Flex
      className={className}
      data-sal={removeAnimation ? "none" : "slide-up"}
      data-sal-easing={"easeOutQuart"}
      data-sal-duration={removeAnimation ? 0 : 500}
      // data-sal-delay={removeAnimation ? 0 : 300}
      onClick={onClick}
      sx={{
        mx: 3,
        variant: `buttons.${String(variant)}`,
        textTransform: "uppercase",
        position: "relative",
        letterSpacing: "1.7px",
        textDecoration: "none",
        alignItems: "center",
        width: "fit-content",
        borderBottom: "3px solid transparent",
        transition: "all .3s ease",
        zIndex: 1,
        a: {
          textDecoration: "none",
          color: `inherit`,
          fontSize: large ? [18, null, null, null, null, 40] : "text.p",
        },
        "&::after": {
          content: '"▶"',
          position: "relative",
          pl: 1,
          fontSize: [16],
        },
        "&:hover": {
          bg: isOutline ? buttons[variant]?.color : "none",
          color: isOutline ? "brand.green" : "",
          borderBottom: "3px solid",
          borderBottomColor: isOutline
            ? "brand.green"
            : buttons[variant]?.color,
          transition: "all .3s ease",
          a: {
            transform: "translateX(0px)",
          },
        },
      }}
    >
      {to ? (
        <Link
          to={to}
          sx={{
            transform: "translateX(0px)",
            transition: "transform .3s ease-in-out",
          }}
        >
          {text}
        </Link>
      ) : type == "submit" ? (
        <button
          sx={{
            variant: "buttons.blue",
            bg: "white",
            textTransform: "uppercase",
          }}
          ref={ref}
          id={id}
          aria-label={ariaLabel}
          onClick={() => onClick()}
          type={type}
          disabled={disabled}
        >
          {text}
        </button>
      ) : (
        <a
          href={href}
          sx={{
            transform: "translateX(0px)",
            transition: "all .3s ease-in-out",
          }}
        >
          {text}
        </a>
      )}
    </Flex>
  );
};

export default Button;
